import store from '@/store'

/**
 * 資料検索の検索画面を別ウィンドウで開く
 */
export const openPrecedentSearch = (id) => {
  // 別ウィンドウで開く
  if (store.state.common.device === 'sp') {
    window.open('/lc/app/sp/document-search/', '_blank')
  } else {
    window.open('/lc/app/pc/document-search/', '_blank')
  }
}

/**
 * 資料検索の一覧画面を書籍リビジョン指定で開く
 */
export const openPrecedentListWithRevisionID = (id) => {
  // 別ウィンドウで開く
  if (store.state.common.device === 'sp') {
    window.open('/lc/app/sp/document-list/' + id, '_blank')
  } else {
    window.open('/lc/app/pc/document-list/' + id, '_blank')
  }
}

/**
 * 資料検索の詳細画面を別ウィンドウで開く
 */
export const openPrecedentTheme = (id) => {
  // 別ウィンドウで開く
  if (store.state.common.device === 'sp') {
    window.open('/lc/app/sp/document-list/theme/' + id, '_blank')
  } else {
    window.open('/lc/app/pc/document-list/theme/' + id, '_blank')
  }
}

/**
 * 資料検索の詳細画面を別ウィンドウで開く
 */
export const openPrecedentDetail = (id) => {
  // 別ウィンドウで開く
  if (store.state.common.device === 'sp') {
    window.open('/lc/app/sp/document-list/detail/' + id, '_blank')
  } else {
    window.open('/lc/app/pc/document-list/detail/' + id, '_blank')
  }
}
